var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpendCategoryUtilities32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DDL-CBA---Icons-Mobile",
    transform: "translate(-1902.000000, -796.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon//SpendCategory/Utilities32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconUtilities-",
    transform: "translate(4.000000, 5.000000)",
    fill: "#706D6E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PostBill"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom",
    points: "0 11 1 11 1 22 23 22 23 11 24 11 24 23 0 23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Document",
    transform: "translate(7.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    points: "5.30628706 6 7.02565835 0.841886117 7.97434165 1.15811388 6.69371294 5 9.69371294 5 7.97434165 10.1581139 7.02565835 9.84188612 8.30628706 6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Writing",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bottom",
    x: 0,
    y: 2,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Top",
    x: 0,
    y: 0,
    width: 4,
    height: 1
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Top",
    points: "4 0 20 0 20 14 19 14 19 1 5 1 5 14 4 14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    points: "19.3787322 9.48507125 19.6212678 8.51492875 24 10.6096118 24 12.3265376 12 17.5953895 -1.77635684e-15 12.3265376 -1.77635684e-15 10.6096118 4.37873219 8.51492875 4.62126781 9.48507125 1 11.3903882 1 11.6734624 12 16.5032433 23 11.6734624 23 11.3903882"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendCategoryUtilities32);
export default __webpack_public_path__ + "static/media/spendCategoryUtilities32.d0b012fa384df28dc41c6c02d470c1cc.svg";
export { ForwardRef as ReactComponent };